import PetsConfigurationTags from '@/modules/pets/common/models/APP/PetsConfigurationTags'
import Configurations from '@/modules/common/common/models/APP/Configuration'
import schema from '@/modules/pets/common/schemas/APP/PetsConfigurationsSchema'
import { validate } from '@/utils/schemaValidatorUtils'
import { PetConfigTypes } from './PetConfigTypes'
import type { OptionsValuesInterface } from '@/modules/core/models/types'
import { PetsHiringMaxAges } from './PetsHiringMaxAges'

export default class PetsConfigurations extends Configurations {
  tags!: PetsConfigurationTags
  petTypes!: PetConfigTypes
  hiringMaxAges: PetsHiringMaxAges

  constructor(data: any = {}) {
    if (data && Object.keys(data).length > 0) {
      validate(schema, data)
    }

    super(data)

    if (data?.petTypes) {
      this.petTypes = new PetConfigTypes(data?.petTypes)
    }
    if (data?.tags) {
      this.tags = new PetsConfigurationTags(data.tags)
    }
    this.hiringMaxAges = new PetsHiringMaxAges(data.hiringMaxAges)
  }

  petTypesOptions(): OptionsValuesInterface[] {
    return this.parseToOptions(this.petTypes)
  }
}
